import type { TweetResponseMediaLinksItemProjectInfoEngagementAllOf } from './tweetResponseMediaLinksItemProjectInfoEngagementAllOf';
import type { TweetResponseMediaLinksItemProjectInfoEngagementAllOfTwo } from './tweetResponseMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type TweetResponseMediaLinksItemProjectInfoEngagement = TweetResponseMediaLinksItemProjectInfoEngagementAllOf & TweetResponseMediaLinksItemProjectInfoEngagementAllOfTwo;
